import { Box, Container, Grid } from '@mui/material'
import { SectionHeading } from '@/components/common'
import { services } from '@/data/services'
import { ServiceCard } from './ServiceCard'
import { SECTION_IDS } from '@/utils/constants'

/**
 * Services Section Component
 * Displays service offerings for plumbing companies
 */
export const ServicesSection = () => {
  return (
    <Box
      component="section"
      id={SECTION_IDS.SERVICES}
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" underline>
          Website Services for Plumbing Companies
        </SectionHeading>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {services.map((service) => (
            <Grid item xs={12} sm={6} md={6} key={service.id}>
              <ServiceCard service={service} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
